import { useEffect, useState } from "react";
import useTitleStore from "../../store/titleStore";
import { Card, Flex, Grid, Segmented, Typography } from "antd";
import { Icon } from "@iconify/react/dist/iconify.js";
import pallete from "../../utils/pallete";
import AllDocumentsTab from "./ProcessAll";
import MyDocumentsTab from "./ProcessMy";

export default function ProcessDocumentAnalysis() {
  const breakpoint = Grid.useBreakpoint();
  const { setTitle } = useTitleStore();
  const [tab, setSelectedTab] = useState("all");

  useEffect(() => {
    setTitle("Analisis Berkas - Analisa Officer");
  }, [setTitle]);

  return (
    <Card
      styles={{
        body: {
          paddingLeft: 0,
          paddingRight: 0
        }
      }}
    >
      <Flex justify="end" style={{ paddingInline: 24, marginBottom: 24 }}>
        <Segmented
          value={tab}
          onChange={(curr) => setSelectedTab(curr)}
          size="middle"
          block={!breakpoint.lg}
          style={{ width: breakpoint.lg ? null : '100%' }}
          options={[
            {
              label: (
                <Typography.Text>
                  <Icon
                    icon={'solar:documents-bold-duotone'}
                    width={18}
                    style={{ marginBottom: -3, marginRight: 8 }}
                    color={pallete.primary.main}
                  />
                  Semua Berkas
                </Typography.Text>
              ),
              value: 'all'
            },
            {
              label: (
                <Typography.Text>
                  <Icon
                    icon={'solar:document-add-bold-duotone'}
                    width={18}
                    style={{ marginBottom: -3, marginRight: 8 }}
                    color={pallete.primary.main}
                  />
                  Berkas Saya
                </Typography.Text>
              ),
              value: 'my'
            },
          ]}
        />
      </Flex>

      {tab === 'all' && <AllDocumentsTab />}
      {tab === 'my' && <MyDocumentsTab />}
    </Card>
  );
}